export default "__VITE_ASSET__5abdc5ca__"